import { InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";
import jwtService from 'services/jwtService';
import {initialProjects} from "constants/common";
import EventsEmitter from "events/EventsEmitter";

export const ConnectionState = {
    IDLE: 0,
    NEEDS_LOGIN: 1,
    WAS_REDIRECTED: 2,
    CONNECTING: 3,
    CONNECTED: 4,
    ERROR: 5,
};

const MAX_TRIALS = 3;
/*
const request = {
    scopes: ["User.Read"],
};
*/

const handleError = (error: any, callback: any) => {
    console.error("Msal.loginRirect.Error:", error);
    if (AuthService.trials < MAX_TRIALS) {
        AuthService.connectionState = ConnectionState.NEEDS_LOGIN;
        AuthService.trials++;
    } else {
        AuthService.connectionState = ConnectionState.ERROR;
    }
    callback(AuthService.connectionState);
};

export default class AuthService {
    static accessToken: string = "";
    static clientApp: IPublicClientApplication | null = null;
    static tokenResponse: any = null;
    static needLogin: boolean = false;
    static userName: string;
    static userEmail: string;
    static connectionState: number = ConnectionState.IDLE;
    static connectionError: string = "";
    static trials: number = 0;

    static setClientApp(clientApp: IPublicClientApplication | null) {
        AuthService.clientApp = clientApp;
        AuthService.trials = 0;
    }

    static getClientApp(): IPublicClientApplication | null {
        return AuthService.clientApp;
    }

    static setAccount(user: string, email: string) {
        AuthService.userName = user;
        AuthService.userEmail = email;
    }

    static logout() {
        const { clientApp } = AuthService;
        if (clientApp != null) {
            clientApp.logoutRedirect()  // optional, where to go after logout
        }
    }

    static loginRedirect() {
        const { clientApp } = AuthService;
        if (clientApp != null) {
            clientApp.loginRedirect().catch((error) => {
                handleError(error, () => {});
            });
        } else {
            AuthService.connectionState = ConnectionState.ERROR;
        }
    }

    static createGlobalUser = async (email: any, description : any) => {
        const endpoint = process.env.REACT_APP_BASE_URL + '/vf/add-global-user';
        let response = await jwtService.fetchRequest({
            method: 'POST',
            url: endpoint,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            data: {
                email : email, 
                accessLevel : 'full', 
                description : description, 
                lastname : '', 
                key_id : process.env.REACT_APP_BASE_APIKEY
            }
        });

        console.log("Response Global user : " + JSON.stringify(response.data) + '................')

        return response.data;
    }

   
    static addProjects2user = (elem:any) => {
        
        
        const endpoint = process.env.REACT_APP_BASE_URL + '/vf/add-user-project';
        const response = jwtService.fetchRequest({
            method: 'POST',
            url: endpoint,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            data: {
                email : elem.user, 
                projectId : elem.project, 
                access_level : 'read',
                key_id : process.env.REACT_APP_BASE_APIKEY
            }
        });

        return response;

    }


    static addAdditionalUserInfo = async (elem:any) => {

        const res = await jwtService.fetchRequest({
			method: 'GET',
			url: '/file.ashx?action=subcription',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${AuthService.getToken()}`,
            },
		});
        const usageHours = res.data[0].hours;

        const endpoint = process.env.REACT_APP_BASE_URL + '/user/first/logged';
        const response = jwtService.fetchRequest({
            method: 'POST',
            url: endpoint,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            data: {
                id : elem.id, 
                name : elem.name, 
                email : elem.email,
                provider : elem.provider,
                usage : usageHours,
                key_id : process.env.REACT_APP_BASE_APIKEY
            }
        });
        return response;
    }



    static authenticate(callback: any) {
        const { clientApp } = AuthService;

        if (clientApp != null) {
                    
            clientApp
                .handleRedirectPromise()
                .then((authResult) => {
                    console.log("authResult:", authResult);
                    const account = clientApp.getActiveAccount();
                    console.log(JSON.stringify(account))

                    
                    //console.log('Account : ' + JSON.stringify(account))
                    if (account === null) {
                        // redirect anonymous user to login page
                        clientApp.loginRedirect().catch((error) => {
                            handleError(error, callback);
                        });
                    } else {
                        const request = {
                            //scopes: ["User.Read"], // Replace with the scopes you need
                            //account: clientApp.getAllAccounts
                            scopes: ["https://voxelspacevisi.onmicrosoft.com/api/read"],
                            prompt: "select_account"
                        };
                        
                        clientApp.acquireTokenSilent(request)
                            .then(response => {
                            
                                if (AuthService.accessToken === "") {
                                    AuthService.tokenResponse = response.accessToken;
                                    AuthService.accessToken = response.idToken.trim();
                                    AuthService.connectionState = ConnectionState.CONNECTED;
                                    
                                    const { account } = response;
                                    if (account) {
                                        const name: string = account.name || "guest";
                                        const username: string = account.username;
                                        AuthService.setAccount(name, username);
                                        const storeGlobalUser = localStorage.getItem("createGlobalUserV4_" + btoa(account.username));


                                         //Send user info the first he connects in order to get his email & provider
                                        const newLoggedUser = {
                                            id : account.localAccountId,
                                            name : account.name,
                                            email : btoa(account.username),
                                            provider : account.idTokenClaims?.idp
                                        }

                                        AuthService.addAdditionalUserInfo(newLoggedUser)

                                       
                                        if(storeGlobalUser === null){

                                            //Create global ==========================
                                            console.log("Response Creation Global user : -----------------------")
                                            AuthService.createGlobalUser(account.username, 'Create a global user from website')
                                            .then(response => {
                                                console.log("Response Creation Global user : " + response.success)
                                                if(response){
                                                    localStorage.setItem("createGlobalUserV4_" + btoa(account.username), btoa(account.username));
                                                    const projectsPromises: any[] = [];
                                                    EventsEmitter.emit("loading_environment", true);

                                                    initialProjects.forEach(element => {
                                                        const elem = {
                                                            user : username,
                                                            project : element,
                                                            accessLevel : 'read',
                                                        }
                                                        console.log(`Call API to set project ${elem.project} to user ${username}`)
                                                        projectsPromises.push(AuthService.addProjects2user(elem))
                                                    });

                                                    Promise.allSettled(projectsPromises).then((results) => {
                                                        EventsEmitter.emit("reloadData", "");
                                                        EventsEmitter.emit("loading_environment", false);

                                                    });
                                                }
                                            })
                                        }
                                    }
                                    callback(AuthService.connectionState);
                                }
                            })
                            .catch(error => {
                                console.log(error);
                                if (error instanceof InteractionRequiredAuthError) {
                                    // fallback to interaction when silent call fails
                                    var request = {
                                        scopes: ["User.Read"],
                                    };
                                    return clientApp.acquireTokenRedirect(request)
                                }
                            });
                    }
                })
                .catch((error) => {
                    console.log('Cancel login error : ' + JSON.stringify(error))
                    if (error instanceof InteractionRequiredAuthError) {
                        if (error.errorCode === "user_cancelled") {
                            console.log("User cancelled the sign-in process.");
                        } else {
                            console.log("Interaction required:", error.message);
                        }
                    } else {
                        console.error("Login needed:", error);
                        clientApp.loginRedirect().catch((error) => {
                            handleError(error, callback);
                        });
                    }
                });
        }
    }

    static getToken(): string | null {
        return AuthService.accessToken;
    }

    static getUserName(): string {
        if (AuthService.userName) {
            return AuthService.userName;
        }
        return "Guest";
    }

    static getUserId(): string {
        return AuthService.userEmail || "Guest";
    }
}
